<template>
  <div>
    <div class="day">
      <div class="day__header">
        <div class="day__header-date">{{ prepareDate(date) }} </div>
        <div class="day__header-visits">Сессии: {{ visits }}</div>
      </div>
      <div class="day__content">
        <conversion-product-table :data="products" />
      </div>

    </div>
  </div>
</template>

<script>
import ConversionProductTable from "./conversionProductsTable";
export default {
  name: 'conversion-product-day',
  components: {
    ConversionProductTable
  },
  props: {
    date: {
      type: Date,
      require: true,
    },
    visits: {
      type: Date,
      require: true,
    },
    products: {
      type: Object,
      require: true,
    }
  },
  methods: {
    prepareDate() {
      const date = new Date(this.date);

      const year = date.getFullYear();
      const month = date.getMonth() + 1
      const day = date.getDate();

      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style lang="scss">
.day {
  background-color: var(--color-border);
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 30px;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-weight: 600;
    margin-bottom: 20px;
  }
}
</style>